var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgA1SocketSimpleRj45(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 69h62V7H7v62zm4-58h54v54H11V11zm16 19h22v12h-6v5H33v-5h-6V30z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/A1_Socket_Simple_RJ45.0f7b472c.svg";
export { SvgA1SocketSimpleRj45 as ReactComponent };